import * as Yup from "yup";

export const reportModalInitialValues = {
  details: "",
};

export const reportModalValidationSchema = Yup.object().shape({
  details: Yup.string().trim(),
});

export const reportCategories = [
  {
    id: "under18",
    name: "Problem Involving Individuals Under 18",
    subcategories: [
      { id: "exploitation", name: "Appears to be Sexual Exploitation" },
      {
        id: "intimateImages",
        name: "Threatening to distribute Intimate Images",
      },
      { id: "privateImages", name: "Sharing someone else’s Private Images" },
      {
        id: "harassment",
        name: "Bullying or Harassment",
      },
      { id: "physicalAbuse", name: "Physical Abuse" },
    ],
  },
  {
    id: "bullyingHarassment",
    name: "Bullying, Harassment, or Abuse",
    subcategories: [
      { id: "photos", name: "Threatening to distribute my Private Photos" },
      {
        id: "exploitationBullyingHarassment",
        name: "Appears to be Sexual Exploitation",
      },
      { id: "trafficking", name: "Appears to involve Human Trafficking" },
      {
        id: "harassmentBullyingHarassment",
        name: "Bullying or Harassment",
        subcategories: [
          { id: "directedAtMe", name: "Directed at Me" },
          { id: "directedAtFriend", name: "Directed at a Friend" },
          { id: "directedAtUnknown", name: "Directed at Someone Unknown" },
        ],
      },
    ],
  },
  {
    id: "selfHarm",
    name: "Suicide or Self-Harm",
    subcategories: [
      { id: "suicideInjury", name: "Suicide or Self-Injury" },
      { id: "eatingDisorders", name: "Eating Disorders" },
    ],
  },
  {
    id: "violentContent",
    name: "Violent, Hateful, or Disturbing Content",
    subcategories: [
      { id: "safetyThreat", name: "Serious Threat to Safety" },
      { id: "terrorism", name: "Appears to involve Terrorism" },
      { id: "violence", name: "Advocating for Violence" },
      { id: "organizedCrime", name: "Appears to involve Organized Crime" },
      {
        id: "hatred",
        name: "Promoting Hatred",
        subcategories: [
          { id: "hateGroup", name: "Represents an Organized Hate Group" },
          { id: "hateSpeech", name: "Posting Offensive or Hate Speech" },
        ],
      },

      {
        id: "depictingViolence",
        name: "Depicting Violence, Death, or Severe Injury",
      },
      { id: "animalCruelty", name: "Animal Cruelty" },
    ],
  },
  {
    id: "illegalItems",
    name: "Selling or Promoting Restricted or Illegal Items",
    subcategories: [
      {
        id: "drugs",
        name: "Drugs",
        subcategories: [
          {
            id: "addictiveSubstances",
            name: "Highly addictive substances like Cocaine, Heroin, or Fentanyl",
          },
          { id: "illicitDrugs", name: "Other Illicit Drugs" },
        ],
      },

      { id: "weapons", name: "Weapons" },
      { id: "animals", name: "Animals" },
    ],
  },
  {
    id: "adultContent",
    name: "Adult Content",
    subcategories: [
      {
        id: "privateImagesAdultContent",
        name: "Threatening to distribute my Private Images",
      },
      { id: "privateImagesOfMe", name: "These are Private Images of me" },
      { id: "prostitution", name: "Appears to involve Prostitution" },
      {
        id: "exploitationAdultContent",
        name: "Appears to be Sexual Exploitation",
      },
      { id: "nudity", name: "Nudity or Sexual Behavior" },
    ],
  },
  {
    id: "scamFraud",
    name: "Scam, Fraud, or False Information",
    subcategories: [
      { id: "fraud", name: "Fraud or Scam" },
      {
        id: "falseInfo",
        name: "Spreading False Information",
        subcategories: [
          { id: "health", name: "Related to Health" },
          { id: "politics", name: "Related to Politics" },
          { id: "socialIssues", name: "Related to Social Issues" },
        ],
      },
      { id: "spam", name: "Spam" },
      { id: "pretendingBusiness", name: "Pretending to represent a Business" },
    ],
  },
  {
    id: "notInterested",
    name: "Not Interested in this Content",
    subcategories: [],
  },
];

export const REPORT_LOCATION_MAP = {
  USER: 1,
  WHEEL: 2,
  SEGMENT: 3,
  MEDIA: 4,
  BUSINESS_BOX: 5,
};
